<div id="report-content" dir="ltr">
    <div class="p-2 pt-0 container">
        <div class="card px-10 pb-10 pt-5" >
          <div class="grid grid grid-cols-2">
            <div>
              <div class="qr-code-container">
                <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
              </div>
             
            </div>
      
            
            <div class="text-right body-1 flex flex-col items-end font-arabic">
              <!-- Image and Table Side by Side -->
                
             

              <div>
                <img src="assets/img/towa_logo.png" />

              </div>
             
      
              
            </div>
          </div>
      
          <div>
            <h1 class="font-arabic m-0 text-center flex items-center justify-center header" style="font-weight: bolder; line-height: normal;">امـــر تـحـمـيـل</h1>
          </div>

          <div class="grid grid-cols-2">
            <!-- <div class="mt-0 text-left font-arabic ml-5">
              <div class="text-left body-2">
                <h1 class="mt-0 font-arabic sub-header text-gray-500" style="font-weight: bold;">اسـم الـعـمـيـل</h1>
              </div>
              <div class="text-left title">             
                <h1 class="font-arabic m-0 sub-header">{{orderData?.customerName}} </h1>
              </div>
 
              <h1 class="font-arabic title m-0 sub-header text-gray-500">( {{orderData?.customerRefNo}} )</h1>
              <div class="font-arabic">
                  
                    <div>
                      <h1 class="m-0 mt-3 font-arabic text-gray-500" style="line-height: 20px;">{{orderData?.customerAddressName}}</h1>
                      <h1 class="m-0 p-0 font-arabic text-gray-500" style="line-height: 20px;">{{orderData?.customerAddressCity}}</h1>
                      <h1 class="m-0 p-0 font-arabic text-gray-500" style="line-height: 20px;">{{orderData?.customerAddressCountry}}</h1>

                    </div>

              </div>
            </div> -->

            <div class="text-right body-1 flex flex-col items-end mt-0 mr-20">
              <table >
                <tbody>
                <tr>
                  <td class="text-right pr-4 "><div class="">             
                    <h1 class="font-arabic m-0 size-12 ">{{orderData?.customerName}} </h1>
                  </div></td>
                    <td >                   <div class="text-right ">
                      <h1 class="font-arabic m-0 sub-header text-gray-500">اسـم الـعـمـيـل  </h1></div></td>
                  
                </tr>
                <tr>
                  <td class="text-right pr-4 size-12">{{orderData?.customerRefNo}}</td>
                  <td >
                    <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الـرقـم الـمـرجـعـي</h1></div>
                    </td>
                </tr>

                <tr>
                  <td class="text-right pr-4 "><div>
                    <h1 class="m-0 font-arabic size-12" style="line-height: 20px;">{{orderData?.customerAddressName}} - {{orderData?.customerAddressCity}} - {{orderData?.customerAddressCountry}}</h1>
                    <!-- <h1 class="m-0 p-0 font-arabic text-gray-500" style="line-height: 20px;">{{orderData?.customerAddressCity}}</h1>
                    <h1 class="m-0 p-0 font-arabic text-gray-500" style="line-height: 20px;">{{orderData?.customerAddressCountry}}</h1> -->

                  </div></td>
                  <td >
                    <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الـعــنـــوان</h1></div>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="mt-0">
              <div class="text-right body-1 flex flex-col items-end">
                <table >
                  <tbody>
                  <tr>
                    <td class="text-right pr-4 size-12">{{orderData?.orderNumber}}</td>
                      <td >                   <div class="text-right ">
                        <h1 class="font-arabic m-0 sub-header text-gray-500">رقم امـر الـتـحـمـيـل </h1></div></td>
                    
                  </tr>
                  <tr>
                    <td class="text-right pr-4 size-12">{{orderData?.transactionDate | date:'dd-MM-yyyy'}}</td>
                    <td >
                      <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الــتــاريـخ</h1></div>
                      </td>
                  </tr>

                  <tr>
                    <td class="text-right pr-4 "> <div class="">  
                      <h1 class="font-arabic m-0 size-12 ">{{orderData?.factoryCode}} - {{orderData?.factoryName}}</h1></div></td>
                    <td >
                      <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الـمـصـنـع</h1></div>
                      </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="text-right body-2">
                <h1 class="mt-0 font-arabic sub-header text-gray-500" style="font-weight: bold; ">الـمـصـنـع</h1>
              </div>
              <div class="text-right title">  
                <h1 class="font-arabic m-0 sub-header">{{orderData?.factoryName}} <span>
                  <h1 class="font-arabic m-0 sub-header text-gray-500">- {{orderData?.factoryCode}} </h1>
                </span></h1>
                          
              </div> -->
              <!-- <h3 class="title m-0">{{orderData?.factoryName}}</h3> -->
              <!-- <div class="font-arabic">
                <p class="m-0">907 Eastern Pkwy</p>
                <p class="m-0">Brooklyn, NY</p>
                <p class="m-0">11213, USA</p>
    
                <p class="m-0 mt-3">
                  <mat-icon class="mr-2 icon-sm" svgIcon="mat:mail"></mat-icon>
                  <span>hello&#64;example.com</span>
                </p>
    
                <p class="m-0">
                  <mat-icon class="mr-2 icon-sm" svgIcon="mat:phone"></mat-icon>
                  <span>+1 (961) 400-3535</span>
                </p>
              </div> -->
            </div>
          </div>

          
          <table class="table w-full mt-5">
            <thead style="background-color: aliceblue;">
            <tr>
              <td>
                <div class="text-center body-2"><h1 class="font-arabic normalText">الـمـنـتـج</h1></div>
              </td>
              <td>
                <div class="text-center body-2"><h1 class="font-arabic normalText">الـوصـف</h1></div>

              </td>
              <td>
                <div class="text-center body-2"><h1 class="font-arabic normalText">الـكـمـيـة - {{orderData?.itemUOM}}</h1></div>

              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="py-1 border-b text-center normalText">{{orderData?.itemCode}} </td>
              <td class="py-1 border-b">
                <div class="text-center body-2"><h1 class="font-arabic normalText"> {{orderData?.itemName}}</h1></div>
                </td>
              <td class="py-1 border-b text-center normalText">{{orderData?.quantity}} </td>
            </tr>
      
            <!-- <tr>
              <td class="py-6 border-b">
                Graphic Pack - Monthly Subscription (includes Updates)
              </td>
              <td class="py-6 border-b">$49.99</td>
              <td class="py-6 border-b">User</td>
            </tr>
      
            <tr>
              <td class="py-6 border-b">Logo & Branding Pack</td>
              <td class="py-6 border-b">$499.99</td>
              <td class="py-6 border-b">Piece</td>

            </tr>
      
            <tr>
              <td class="py-6 border-b">Bug Fixes</td>
              <td class="py-6 border-b">$15.00</td>
              <td class="py-6 border-b">Hour</td>

            </tr> -->
            </tbody>
          </table>

          
          <table class="table w-full mt-5">
            <thead style="background-color: aliceblue;">
            <tr>
              <td>
                <div class="text-center body-2"><h1 class="font-arabic normalText">اسـم الـسـائـق</h1></div>
              </td>
              <td>
                <div class="text-center body-2" ><h1 class="font-arabic normalText">رقـم الـشـاحـنـة</h1></div>
              </td>
              <td>
                <div class="text-center body-2" ><h1 class="font-arabic normalText">رقـم الـلـوحـة</h1></div>
              </td>
              <td>
                <div class="text-center body-2" ><h1 class="font-arabic normalText">الـنـاقـل</h1></div>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="py-1 border-b text-center"><div class="text-center body-2"><h1 class="font-arabic normalText"> {{selectedDriver}}</h1></div>
              </td>
              <td class="py-1 border-b">
                <div class="text-center body-2"><h1 class="font-arabic normalText"> {{selectedVehicle}}</h1></div>
                </td>
                <td class="py-1 border-b text-center normalText">{{selectedPlateNumber}} </td>
              <td class="py-1 border-b text-center normalText">{{selectedTransporter}} </td>
            </tr>
      
            <!-- <tr>
              <td class="py-6 border-b">
                Graphic Pack - Monthly Subscription (includes Updates)
              </td>
              <td class="py-6 border-b">$49.99</td>
              <td class="py-6 border-b">User</td>
            </tr>
      
            <tr>
              <td class="py-6 border-b">Logo & Branding Pack</td>
              <td class="py-6 border-b">$499.99</td>
              <td class="py-6 border-b">Piece</td>

            </tr>
      
            <tr>
              <td class="py-6 border-b">Bug Fixes</td>
              <td class="py-6 border-b">$15.00</td>
              <td class="py-6 border-b">Hour</td>

            </tr> -->
            </tbody>
          </table>

         
          <!-- <div class="mt-8 flex flex-col items-end">
            <table class="subheading-2 font-medium pr-6">
              <tbody>
              <tr>
                <td class="font-arabic text-right">SUBTOTAL</td>
                <td class="pl-12">$2,299.94‬</td>
              </tr>
              <tr>
                <td class="font-arabic text-right">TAX (19%)</td>
                <td class="pl-12">$436.99‬</td>
              </tr>
              <tr>
                <td class="font-arabic text-right">DISCOUNT (5%)</td>
                <td class="pl-12">-$114.99‬</td>
              </tr>
              <tr>
                <td class="headline font-medium text-right pt-6">TOTAL</td>
                <td class="headline font-medium pl-12 pt-6">$2,621.94‬</td>
              </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </div>
      
  </div>
